module.exports = __webpack_public_path__ + "img/concrete-hole-decal-15.b42ea4cd.png";